__webpack_require__.p = "/assets/turbo/df1ca89c/universalat/_next/";